import { storageDateFormat } from '@/core';
import deepCopy from 'deepcopy';
import moment from 'moment';
import searchFilterMutations from './searchFilter/tripSearch.mutations.js';

let setValue = (state, { key, value }) => state[key] = value;

let setTrips = (state, { trips, externalTrips }) => {
	state.trips = trips.concat(externalTrips).filter(x => Boolean(x)); // Filter out potential bad data
};

let ediSent = (state, id) => {
	state.tripsSentOnEdi.push(id);
};

let loadSavedSearch = (state, savedSearch) => {
	if (!savedSearch) return;
	state.loadedSearch = { ...savedSearch };

	if (savedSearch.id === -1) { // reset
		state.searchFilter = {
			etd: {
				from:moment().startOf('day')
					.subtract(7,'d')
					.format(storageDateFormat),
				to:''
			},
			fromLocation: [],
			toLocation: [],
			tripType: [],
			status: [],
			cargoCarrier: [],
		};
		state.loadedSearch = { id:-1, labelKey: 'tripSearch.searchForTrips' };
	} else {
		if (savedSearch.timeInterval.before) {
			let date = moment().add(savedSearch.timeInterval.before,'d').startOf('day');
			state.searchFilter.etd.from = date.format(storageDateFormat);
		}
		if (savedSearch.timeInterval.after) {
			let date = moment().add(savedSearch.timeInterval.after,'d').endOf('day');
			state.searchFilter.etd.to = date.format(storageDateFormat);
		}
		state.searchFilter.fromLocation = deepCopy(savedSearch.fromLocation || []);
		state.searchFilter.toLocation = deepCopy(savedSearch.toLocation || []);
		state.searchFilter.tripType = deepCopy(savedSearch.tripType || []);
		state.searchFilter.status = deepCopy(savedSearch.status || []);
		state.searchFilter.cargoCarrier = deepCopy(savedSearch.cargoCarrier || []);
	}
};
let setTripDetails = (state, tripId) => {
	let trip = state.trips.find(({ id }) => id === tripId);
	if (!trip) return;
	state.tripDetails = trip;
};

let setTrip = (state, trip) => {
	let index = state.trips.findIndex(x => x.id === trip.id);
	if (index === -1) {
		state.trips.push(trip);
	} else {
		state.trips[index] = trip;
		if (state.tripDetails.id === trip.id)
			state.tripDetails = state.trips[index];
	}
};

function updateTrips(state, trips) {
	for (let trip of trips) {
		let index = state.trips.findIndex(x => x.id === trip.id);
		if (index === -1) {
			state.trips.push(trip);
		} else {
			state.trips[index] = trip;
			if (state.tripDetails.id === trip.id)
				state.tripDetails = state.trips[index];
		}
	}
}


let setTripOrders = (state, { id, orders }) => {
	let index = state.trips.findIndex(x => x.id === id);

	if (index === -1) {
		return;
	} else {
		let { length } = state.trips[index].orders;
		state.trips[index].orders.splice(0, length, ...orders);
		if (state.tripDetails && state.tripDetails.id === id)
			state.tripDetails = state.trips[index];
	}
};

export default {
	setValue,
	setTrips,
	loadSavedSearch,
	setTripDetails,
	setTrip,
	updateTrips,
	ediSent,
	setTripOrders,
	...searchFilterMutations,
};
